// src/pages/NotFound.js

import React from 'react';
import { SearchX, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="relative">
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
          <SearchX className="w-24 h-24 text-indigo-500 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
        </div>
        
        <h2 className="mt-8 text-3xl font-semibold text-gray-800">Page Not Found</h2>
        <p className="mt-4 text-gray-600">
          We couldn't find the page you're looking for. It might have been moved, 
          deleted, or perhaps never existed.
        </p>
        
        <div className="mt-8 space-y-4">
          <Link 
            to="/"
            className="inline-flex items-center justify-center w-full px-5 py-3 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            <Home className="w-5 h-5 mr-2" />
            Back to Login
          </Link>
          
          <button 
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center w-full px-5 py-3 text-base font-medium text-indigo-700 bg-indigo-100 border border-transparent rounded-md hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;